<script>
import {mapState,mapMutations} from "vuex";
import axios from "axios";
import CalendarModal from "./CalendarModal.vue";
import moment from "moment";
import _ from "lodash";

export default {
  name: "ProfileReports",
  components: {CalendarModal},
  data(){
    return {
      sales: null,
      contract_guid:null,
      pageWidth: null,
      open_window: false,
      open_window_month: false,
      selectMonth: false,
      colors_arr: ['green','blue','orange','yellow'],
      select_date_filter: ["Апрель",moment("2025-04-01"),moment("2025-04-01").endOf("month")],
      date_filters: [
        //["Январь", moment("2025-01-01"),moment("2025-01-01").endOf("month")],
        //["Февраль",moment("2025-02-01"),moment("2025-02-01").endOf("month")],
        ["Март",moment("2025-03-01"),moment("2025-03-01").endOf("month")],
        ["Апрель",moment("2025-04-01"),moment("2025-04-01").endOf("month")],
        ["Май",moment("2025-05-01"),moment("2025-05-01").endOf("month")],
        ["Июнь",moment("2025-06-01"),moment("2025-06-01").endOf("month")],
        ["Июль",moment("2025-07-01"),moment("2025-07-01").endOf("month")],
        ["Август",moment("2025-08-01"),moment("2025-08-01").endOf("month")],
        ["Сентябрь",moment("2025-09-01"),moment("2025-09-01").endOf("month")],
        ["Октябрь",moment("2025-10-01"),moment("2025-10-01").endOf("month")],
        ["Ноябрь",moment("2025-11-01"),moment("2025-11-01").endOf("month")],
        ["Декабрь",moment("2025-12-01"),moment("2025-12-01").endOf("month")]]
    }
  },
  computed:{
    smartProjects(){
      var result = this.contracts
      return result
    },
    filterSales() {
      return _.filter(this.sales, (item)=>{
        let sales_end = moment(item.sales_end)
        return item['product'].includes("Аренда недвижимости") && sales_end.month() > 1
      })
    },
    smartMonths(){
      let year = moment().year()
      let months = [
        {
          title: 'Январь ' + year,
          dateObj: moment('01-01-' + year, 'MM-DD-YYYY'),
          daysArr: []
        },
        {
          title: 'Февраль ' + year,
          dateObj: moment('02-01-' + year, 'MM-DD-YYYY'),
          daysArr: []
        },
        {
          title: 'Март ' + year,
          dateObj: moment('03-01-' + year, 'MM-DD-YYYY'),
          daysArr: []

        },
        {
          title: 'Апрель ' + year,
          dateObj: moment('04-01-' + year, 'MM-DD-YYYY'),
          daysArr: []
        },
        {
          title: 'Май ' + year,
          dateObj: moment('05-01-' + year, 'MM-DD-YYYY'),
          daysArr: []

        },
        {
          title: 'Июнь ' + year,
          dateObj: moment('06-01-' + year, 'MM-DD-YYYY'),
          daysArr: []
        },

        {
          title: 'Июль ' + year,
          dateObj: moment('07-01-' + year, 'MM-DD-YYYY'),
          daysArr: []

        },
        {
          title: 'Август ' + year,
          dateObj: moment('08-01-' + year, 'MM-DD-YYYY'),
          daysArr: []
        },

        {
          title: 'Сентябрь ' + year,
          dateObj: moment('09-01-' + year, 'MM-DD-YYYY'),
          daysArr: []

        },
        {
          title: 'Октбярь ' + year,
          dateObj: moment('10-01-' + year, 'MM-DD-YYYY'),
          daysArr: []
        },
        {
          title: 'Ноябрь ' + year,
          dateObj: moment('11-01-' + year, 'MM-DD-YYYY'),
          daysArr: []

        },
        {
          title: 'Декабрь ' + year,
          dateObj: moment('12-01-' + year, 'MM-DD-YYYY'),
          daysArr: []
        },
      ]
      for (let b = 0; b < months.length; b++) {
        let dayWeek = months[b].dateObj.isoWeekday()
        // Добавление пустых дней
        for (let c = 1; c < dayWeek; c++) {
          months[b].daysArr.push({
            'day_num': '',
            'class' : 'white'
          })
        }
        // Создание daysArr ячеек из каждого дня
        let cacheMoment
        for (let i = 1; i <= months[b].dateObj.daysInMonth(); i++) {
          cacheMoment = months[b].dateObj.date(i)

          let dayArr = this.checkSalesByDay(cacheMoment, i)
          months[b].daysArr.push(dayArr)
        }
      }

      return months
    },
    ...mapState(['selectContract', 'contracts', 'profileApiPrefix'])
  },
  methods:{
    checkSalesByDay(cacheMoment,i){
      let colorArr = []
      let typeCellArr = []
      let resultColor = ''
      let countFindDate = 0
      let resultID = ''
      for (let l = 0; l < this.filterSales.length; l++){
        let sale = this.filterSales[l];
        let dateObjSaleBegin = moment(sale.sales_begin)
        let dateObjSaleEnd = moment(sale.sales_end)
        if (dateObjSaleBegin.diff(cacheMoment) <= 0 && dateObjSaleEnd.diff(cacheMoment) >= 0) {
          countFindDate += 1
          resultID = sale.id
          colorArr.push(this.colors_arr[sale['id'] % 4])
        
          if(dateObjSaleBegin.date() === cacheMoment.date() 
            && dateObjSaleEnd.date() === cacheMoment.date() 
            && dateObjSaleBegin.month() === cacheMoment.month()
            && dateObjSaleEnd.month() === cacheMoment.month()
          ){
            typeCellArr.push('ones')
          }else{
            if(dateObjSaleBegin.date() === cacheMoment.date()
            && dateObjSaleBegin.month() === cacheMoment.month()){
              typeCellArr.push('start')
            }
            if(dateObjSaleEnd.date() === cacheMoment.date()
            && dateObjSaleEnd.month() === cacheMoment.month()){
              typeCellArr.push('end')
            }
          }
          

          if(countFindDate == 2){
            typeCellArr = []
          }
        }

      }
      if(colorArr.length > 0){
        if(colorArr.length === 1){
          resultColor += " " + colorArr[0]
        }else if(colorArr.length === 2){
          resultColor += " " + colorArr[0] + '-' + colorArr[1]
        }
      }
      if(typeCellArr.length > 0){
        if(typeCellArr.length === 1){
          resultColor += " " + typeCellArr[0]
        }else if(typeCellArr.length === 2){
          resultColor += " ones"
        }
      }

      countFindDate = 0
      return {
        'day_num': i,
        'class' : resultColor,
        'id_sale': resultID,
      }
    },
    selectDate(date){
      this.select_date_filter = date
      this.openWindowDateChange()
    },
    openWindowChange(){
      this.open_window_month = false
      this.open_window = !this.open_window
    },
    openWindowDateChange(){
      this.open_window = false
      this.open_window_month = !this.open_window_month
    },
    closeAllModal(){
      let refs = this.$refs
      for (let k in refs) {
        if(k !== 'modalCalendar12'){
          refs[k][0].isActive = false
          refs[k][0].infoContract = []
        }else{
          if(this.pageWidth < 700){
            refs[k].isActive = false
            refs[k].infoContract = []
          }
        }
      }
    },
    clickContract(contract){
      this.closeAllModal()
      if(this.pageWidth < 700){
        this.selectMonth = false
      }
      this.setSelectContract(contract)
      this.openWindowChange()
    },
    queryGetPayments () {
      const contract = this.selectContract
      if (!contract || !contract.rental_object_guid) {
        return
      }
      const prefix = this.profileApiPrefix || '/api/telegram'
      axios.get(prefix + '/get-profile?to_at=2025-05-05 00:00:00&from_at=2020-05-05 00:00:00&rental_object_guid=' + contract.rental_object_guid)
        .then(response => {
          this.sales = response.data.sales
        })
        .catch(error => {
          console.error('Ошибка при получении профиля:', error);
        });
    },
    setSelectMonth(month){
      this.selectMonth = month
      $(".month-box.big-mobile").removeClass("open")
      this.$refs['modalCalendar12'].closeModal()
      this.$refs['modalCalendar12'].infoContract = []
    },
    bigMobileTop(isActive){
      if(isActive === true)
      {
        $(".month-box.big-mobile").removeClass("open")
      }else {
        $(".month-box.big-mobile").addClass("open")
      }
    },
    showModal(key,id_sale, event){
      let saveInfoContractId
      let saveInfoContractActive
      if(key !== 12){
        saveInfoContractId = this.$refs['modalCalendar' + key][0].infoContract.id
        saveInfoContractActive = this.$refs['modalCalendar' + key][0].isActive
      }else{
        saveInfoContractId = this.$refs['modalCalendar' + key].infoContract.id
        saveInfoContractActive = this.$refs['modalCalendar' + key].isActive
      }
      this.closeAllModal()
      let monthEl = $(event.currentTarget).parent().parent().parent();
      let positionLeft =monthEl.position().left
      let sale = _.find(this.filterSales, { 'id': id_sale})
      if(key === 12){

        if(saveInfoContractId !== id_sale){
          if(!saveInfoContractActive){
            this.bigMobileTop(saveInfoContractActive)
          }
          this.$refs['modalCalendar' + key].showModal(sale, positionLeft)
        }else{
          this.bigMobileTop(saveInfoContractActive)
          this.$refs['modalCalendar' + key].isActive = false
          this.$refs['modalCalendar' + key].infoContract = []
        }

      }else{
        if(saveInfoContractId !== id_sale){
          this.$refs['modalCalendar' + key][0].showModal(sale, positionLeft)
        }else{
          this.$refs['modalCalendar' + key][0].infoContract = []
        }

      }
    },
    cursorOver(day){
      if (day.id_sale !== ''){
        $('[data-calendar-id="' + day.id_sale + '"]').addClass("hover")
      } else {
        $('[data-calendar-id="' + day.id_sale + '"]').addClass("empty")
      }
    },
    cursorOut(day){
      $('[data-calendar-id="' + day.id_sale + '"]').removeClass("hover")
    },
    ...mapMutations(["setSelectContract"])
  },
  watch: {
    selectContract: {
      handler () {
        this.queryGetPayments()
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.pageWidth = window.innerWidth
  },
  mounted () {
  },
}
</script>

<template>
  <div class="profile-calendar left">
    <div class="filter-block left">
      <div class="filter-header left" v-if="selectContract">{{selectContract.partner}}</div>
      <div class="filter-body left">
        <div class="left-filter-body left">
          <h2 class="left">выберите объект:</h2>

          <!-- <v-select
            label="Выбор контракта"
            :items="items"
            item-title="contract"
            item-text="contract"
            v-model="selectObjectKey"
          ></v-select> -->


          <div class="code_home left">
            <div class="input" @click="openWindowChange()">
              {{selectContract ? selectContract.rental_object : 'Выберите документ'}}
            </div>
            <div class="window-select" :class="{
                      'show' : open_window,
                      }">
              <span v-for="(item,keyit) in smartProjects" @click="clickContract(item)" v-bind:key="keyit" >{{item.rental_object}}</span>
            </div>
          </div>
          <!-- <div class="pencil left">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.7281 3.82842L17.385 9.48527M14.5565 6.65684L5.36415 15.8492M5.36415 15.8492L2.53572 13.0208M5.36415 15.8492L8.19257 18.6777M7.48547 19.3848L18.7992 8.07106C19.5802 7.29001 19.5802 6.02368 18.7992 5.24263L15.9707 2.4142C15.1897 1.63315 13.9234 1.63315 13.1423 2.4142L1.82861 13.7279L1.82861 19.3848H7.48547Z"  stroke-width="2" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="search">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.6569 14.6569L19 19M8 5C10.7614 5 13 7.23858 13 10M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div> -->
        </div>

<!--        <div class="right-filter-body">-->
<!--          <span class="date">выберите месяц:</span>-->
<!--          <div class="code_home left">-->
<!--            <div class="input" @click="openWindowDateChange()">-->
<!--              {{select_date_filter ? select_date_filter[0] : 'Выберите месяц'}}-->
<!--            </div>-->
<!--            <div class="window-select" :class="{-->
<!--                      'show' : open_window_month,-->
<!--                      }">-->
<!--              <span v-for="(item,keyit) in date_filters" @click="selectDate(item)" v-bind:key="keyit" >{{item[0]}}</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <div class="calendar-block left">
      <Transition name="fade-big-mobile" mode="out-in">
        <span class="month-box big-mobile left" v-if="selectMonth" >
          <span class="month-title left flex flex-x-center">
            {{ selectMonth.title }}
          </span>
          <span class="date-table left flex flex-column">
            <span class="date-table-week left">
              <span class="date-table-week-letter left flex flex-xy-center">П</span>
              <span class="date-table-week-letter left flex flex-xy-center">В</span>
              <span class="date-table-week-letter left flex flex-xy-center">С</span>
              <span class="date-table-week-letter left flex flex-xy-center">Ч</span>
              <span class="date-table-week-letter left flex flex-xy-center">П</span>
              <span class="date-table-week-letter weekend left flex flex-xy-center">С</span>
              <span class="date-table-week-letter weekend left flex flex-xy-center">В</span>
            </span>
            <span class="date-table-days left">
              <span :data-calendar-id="day.id_sale" class="date-table-day-cell left flex flex-xy-center"
                v-for="day in selectMonth.daysArr"
                :class="day.class"
                @click="showModal(12,day.id_sale,$event)"
                @mouseover="cursorOver(day)"
                @mouseleave="cursorOut(day)"
              >
                {{day.day_num}}
              </span>
            </span>
          </span>
          <calendar-modal key="12" ref="modalCalendar12"></calendar-modal>
        </span>
      </Transition>
      <div class="month-list flex left">

        <span class="month-box left" :class="{
          'mobile-opacity' : selectMonth,
          'opacity-full' : selectMonth && selectMonth.title === month.title
        }" v-for="(month,key) in smartMonths">
          <span class="click-box-month left" v-if="pageWidth < 700" @click="setSelectMonth(month)"></span>
          <span class="month-title left flex flex-x-center">
            {{ month.title }}
          </span>
          <span class="date-table left flex flex-column">
            <span class="date-table-week left">
              <span class="date-table-week-letter left flex flex-xy-center">П</span>
              <span class="date-table-week-letter left flex flex-xy-center">В</span>
              <span class="date-table-week-letter left flex flex-xy-center">С</span>
              <span class="date-table-week-letter left flex flex-xy-center">Ч</span>
              <span class="date-table-week-letter left flex flex-xy-center">П</span>
              <span class="date-table-week-letter weekend left flex flex-xy-center">С</span>
              <span class="date-table-week-letter weekend left flex flex-xy-center">В</span>
            </span>
            <span class="date-table-days left">
              <span :data-calendar-id="day.id_sale" class="date-table-day-cell left flex flex-xy-center"
                v-for="day in month.daysArr"
                :class="day.class"
                    @click="showModal(key,day.id_sale,$event)"
                    @mouseover="cursorOver(day)"
                    @mouseleave="cursorOut(day)"
              >
                {{day.day_num}}
              </span>
            </span>
          </span>
          <calendar-modal :key="key" :ref="'modalCalendar' + key"></calendar-modal>
        </span>
      </div>
    </div>
    <div class="option-calendar-block left"></div>
  </div>
</template>

<style scoped>
.fade-big-mobile-enter-active,
.fade-big-mobile-leave-active{
  transition: height 0.3s ease,opacity 0.3s ease,padding 0.3s ease;
}

.fade-big-mobile-enter-from,
.fade-big-mobile-leave-to {
  height: 0;
  opacity: 0;
  padding:0 1.36rem 0 1.36rem;
}
</style>